import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import ReactGA from "react-ga";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import indexRoutes from "./routes";
import Sitemap from "./sitemap.js";
import AppContainer from "./utils/AppContainer";
const App = () => {
  const userdata = useSelector((state) => state.auth);

  useEffect(() => {
    //getToken(setTokenFound);
    if (userdata && userdata.uuid) {
      ReactGA.initialize("", {
        userId: userdata.uuid,
      });
    }
    window.scroll(0, 0);
  }, []);

  // Google Gtag
  useEffect(() => {
    if (userdata && userdata.uuid) {
      ReactGA.initialize(process.env.REACT_APP_G_TAG, {
        gaOptions: {
          name: userdata.full_name,
          userId: userdata.uuid,
        },
        userId: userdata.uuid,
      });
    } else {
      ReactGA.initialize(process.env.REACT_APP_G_TAG);
    }
  }, [userdata]);

  useEffect(() => {
    const trackingId = process.env.REACT_APP_G_TAG // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);
ReactGA.set({
  username: userdata.full_name,
  // Other relevant user information
})
  })
  // useEffect(() => {
  //   let onmessage = onMessageListener()
  //     .then((message) => {
  //       // notification.info({
  //       //   message: message.notification.title,
  //       //   description: message.notification.body,
  //       //   icon: <BellOutlined style={{ color: '#108ee9' }} />,
  //       // })
  //     })
  //     .catch((err) => console.log("failed: ", err));
  //   return onmessage;
  // });

  return (
    <BrowserRouter>
      <AppContainer>
        <Switch>
          {indexRoutes.map((route, key) => {
            return (
              <Route
                path={route.path}
                component={route.component}
                key={key}
                exact={true}
              />
            );
          })}
          <Route path="/sitemap" component={Sitemap} />
        </Switch>
      </AppContainer>
    </BrowserRouter>
  );
};

export default App;
